<div>
  <div class="mat-h3">Rechnungsnummer</div>
  <p>
    Die Rechnungsnummer wird auf den generierten Rechnungen angezeigt. In diesem Feld können Sie eine Vorlage für die Rechnungsnummer definieren,
    die automatisch beim Erstellen der Rechnung verwendet wird.
  </p>
  <p>Im Folgenden finden Sie eine Übersicht der verfügbaren Platzhalter,
    die Sie für die Erstellung der Vorlage verwenden können:</p>
  <div class="mat-h3">Formatierungscodes Übersicht</div>
  <table>
    <tr><td>yy</td>   <td>:</td> <td>2-stelliges Leistungsjahr (z.B. 23 für 2023)</td></tr>
    <tr><td>yyyy</td> <td>:</td> <td>4-stelliges Leistungsjahr (z.B. 2023)</td></tr>
    <tr><td>mm</td>   <td>:</td> <td>Leistungsmonat (z.B. 01 für Januar)</td></tr>
    <tr><td>dd</td>   <td>:</td> <td>Leistungstag (z.B. 15 für den 15. des Monats)</td></tr>
    <tr><td>pcn</td>  <td>:</td> <td>Sammelnummer (Zahlungskollektiv-Nummer)</td></tr>
    <tr><td>plz</td>  <td>:</td> <td>Postleitzahl des Transports</td></tr>
    <tr><td>tn</td>   <td>:</td> <td>Mandantennummer</td></tr>
    <tr><td>vn</td>   <td>:</td> <td>Versionsnummer der Rechnung</td></tr>
    <tr><td>cn</td>   <td>:</td> <td>Fahrtnummer (Transportnummer)</td></tr>
    <tr><td>space</td><td>:</td> <td>Leerzeichen</td></tr>
    <tr><td>sn</td>   <td>:</td> <td>Fortlaufende Nummer (z.B. 001, 002, 003 für sequentielle Rechnungen)</td></tr>
  </table>
  <p>
    Verwenden Sie diese Platzhalter, um die Rechnungsnummer individuell an Ihre Anforderungen anzupassen.
  </p>
</div>
